// part of nuxt
import type { $Fetch, NitroFetchRequest } from "nitropack"

export function jobRepository<T>(fetch: $Fetch<T, NitroFetchRequest>) {
  return {
    /**
     * Returns job details
     * @param tenantId targeted tenant
     * @param jobId id of the job
     * @param jobShopVanity vanity of the job shop
     * @returns
     */
    async getJobById(tenantId: string, jobShopVanity: string, jobId: string): Promise<FlatJob> {
      return fetch<FlatJob>(`${UrlConfig.PATH_BASE_OFFER_SERVICE}/public/offers/${jobId}/typesense?vanity=${jobShopVanity}`, {
        headers: {
          "Accept": "application/json",
          "X-Tenant-Id": tenantId,
        },
      })
    },
  }
}
